import { Button, SecondaryButton as SecondaryBtn } from '@makemydeal/ui-bricks/dist/cox';
import styled, { css } from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';

type StyledButtonProps = { width?: string; $buttonSize?: 'small' | 'large' };

const getButtonPadding = ($buttonSize?: 'small' | 'large') => ($buttonSize === 'small' ? '8px 20px' : '14px 0');

const getButtonFontSize = (theme: Record<string, any>, key: string, $buttonSize?: 'small' | 'large') =>
    $buttonSize === 'small' ? '14px' : theme.uiBricks?.[`${key}ButtonFontSize`] || theme[`${key}ButtonFontSize`];

//Will update border radius and background color based on the theme and button style in theme User story
export const PrimaryButton = styled(Button)<StyledButtonProps>`
    ${({ theme, width, $buttonSize }) => css`
        width: ${width || '170px'};
        border-radius: 4px;
        border-width: ${theme.uiBricks?.primaryButtonBorderWidth || theme.primaryButtonBorderWidth};
        border-color: ${theme.uiBricks?.primaryButtonBorderColor || theme.primaryButtonBorderColor};
        text-align: center;
        padding: ${getButtonPadding($buttonSize)};
        font-size: ${theme.uiBricks?.primaryButtonFontSize};
        font-weight: ${theme.uiBricks?.primaryFontWeight || theme.primaryFontWeight};
        background: ${theme.uiBricks?.primaryButtonColor};

        @media (max-width: ${BreakPoint.SMALL}) {
            width: 100%;
        }
    `}
`;

//Will update border radius and background color based on the theme and button style in theme User story
export const SecondaryButton = styled(SecondaryBtn)<StyledButtonProps>`
    ${({ theme, width, $buttonSize }) => css`
        width: ${width || '170px'};
        border-radius: 4px;
        border-width: ${theme.uiBricks?.secondaryButtonBorderWidth || theme.secondaryButtonBorderWidth};
        border-color: ${theme.uiBricks?.primaryAccentColor};
        color: ${theme.uiBricks?.primaryAccentColor};
        background-color: #ffffff;
        text-align: center;
        padding: ${getButtonPadding($buttonSize)};
        font-size: ${getButtonFontSize(theme, 'secondary', $buttonSize)};
        font-weight: ${theme.uiBricks?.secondaryFontWeight || theme.secondaryFontWeight};

        @media (max-width: ${BreakPoint.SMALL}) {
            width: 100%;
        }
    `}
`;

export const TertiaryButton = styled.button<StyledButtonProps>`
    ${({ theme, width, $buttonSize }) => css`
        width: ${width || 'auto'};
        background: transparent;
        border: none;
        outline: none;
        text-align: center;
        padding: ${getButtonPadding($buttonSize)};
        font-size: ${getButtonFontSize(theme, 'primary', $buttonSize)};
        font-weight: ${theme.uiBricks?.primaryFontWeight || theme.primaryFontWeight};
        color: ${theme.uiBricks?.primaryButtonBaseColor || theme.primaryButtonBaseColor || 'inherit'};
        cursor: pointer;

        &:hover:not(:disabled) {
            text-decoration: underline;
            opacity: 0.85;
        }

        &:disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }

        @media (max-width: ${BreakPoint.SMALL}) {
            width: 100%;
        }
    `}
`;

export const PrimaryButtonSpinner = styled(PrimaryButton)`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`;

export const SecondaryButtonSpinner = styled(SecondaryButton)`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`;

export const TertiaryButtonSpinner = styled(TertiaryButton)`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`;
